import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect, useState } from 'react';

import { ResetForm } from '@/features/auth/ResetForm';

/**
 * `/reset-password?token=` —— 信裡的連結。
 *
 * token 是一張有效憑證（30 分鐘、單次使用）。讀進元件狀態之後立刻用 `replace` 把它從
 * 網址列拿掉：留在網址上就會進瀏覽歷史、被同步到別的裝置、出現在截圖裡。
 */
export interface ResetPasswordSearch {
  token?: string;
}

export const Route = createFileRoute('/reset-password')({
  validateSearch: (search: Record<string, unknown>): ResetPasswordSearch => {
    const token = search['token'];
    return typeof token === 'string' && token !== '' ? { token } : {};
  },
  component: ResetPasswordRoute,
});

function ResetPasswordRoute() {
  const { token: fromUrl } = Route.useSearch();
  const navigate = useNavigate();
  // 第一次渲染時的值就是全部：網址列上的 token 下一刻就會被拿掉。
  const [token] = useState(fromUrl);

  useEffect(() => {
    if (fromUrl === undefined) return;
    void navigate({ to: '/reset-password', search: {}, replace: true });
  }, [fromUrl, navigate]);

  return <ResetForm token={token} />;
}
